import DottedTitle from './DottedTitle';

export default DottedTitle;
